module.exports = __webpack_public_path__ + "static/img/my-library.2d552e0c.jpg";